import layoutEngine from "./layoutEngine";
import layerLibrary from "../canvas/LayerLibrary";
let instances = {}; // key = cellName, value = { layerId: [rectangles] }


export function hexToRgba(color, alpha = 1) {
  if (!color) return 'rgba(0,0,0,0.4)'; // default fallback color

  if (!color.startsWith("#")) {
    const ctx = document.createElement("canvas").getContext("2d");
    ctx.fillStyle = color;
    color = ctx.fillStyle; // browser converts to hex
  }

  const bigint = parseInt(color.replace("#", ""), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}



// function deleteRectangle(layerId, rectId) {
//   if (!instances[layerId]) return;
//   instances[layerId] = instances[layerId].filter(rect => rect.id !== rectId);
// }
function deleteRectangle(cellName, layerId, rectId) {
  if (!instances[cellName] || !instances[cellName][layerId]) return;
  instances[cellName][layerId] = instances[cellName][layerId].filter(rect => rect.id !== rectId);
}




const InstanceLibrary = {
  addRectangle: (cellName, layerId, x, y, width, height, options = {}) => {
    const rect = {
      id: options.id || Date.now(),
      type: "rectangle",
      x,
      y,
      width,
      height,
      selected: false,
      layerId,
      rotation: options.rotation || 0,
      layer: options.layerNumber ?? 1,
      datatype: options.datatypeNumber ?? 0,
      layerNumber: options.layerNumber ?? 1,  // ✅ ADD THIS
  datatypeNumber: options.datatypeNumber ?? 0,
  opacity: options.opacity,
      ...options
    };
  
    if (!instances[cellName]) instances[cellName] = {};
  if (!instances[cellName][layerId]) instances[cellName][layerId] = [];

  const isDuplicate = instances[cellName][layerId].some(r => r.id === rect.id);
  if (!isDuplicate) {
    instances[cellName][layerId].push(rect);
  }

  const cell = layoutEngine.getCellByName(cellName);
  if (cell && !options.skipElement) {
    cell.elements = cell.elements || [];
    cell.elements.push({
      ...rect,
      type: "rectangle"   // ✅ Needed for drawInstanceTree
    });
  }
  
  },

  getAllInstances: () => instances,
  
  // updateColorByLayer(layerId, newColor) {
  //   const items = instances[layerId] || [];
  //   items.forEach(rect => {
  //     rect.fill = newColor; // or rect.color = newColor if using color
  //   });
  // },
 updateColorByLayer(layerId, newColor) {
  for (const cellName in instances) {
    if (instances[cellName][layerId]) {
      instances[cellName][layerId].forEach(rect => {
        rect.fill = newColor;
        rect.stroke = newColor; // ✅ border bhi change
      });
    }

    // 🔁 Update uploadedCell + layoutCell shapes too
    const layoutCell = layoutEngine.getCellByName(cellName);
    const uploadedCell = layoutEngine.getUploadedCell(cellName);

    [layoutCell, uploadedCell].forEach(cell => {
      if (cell?.elements?.length) {
        cell.elements.forEach(el => {
          const isMatch = el.layerId === layerId && el.type === 'rectangle';
          if (isMatch) {
            el.fill = newColor;
            el.stroke = newColor; // ✅ border bhi change
          }
        });
      }
    });
  }
},

renameCellKey: (oldName, newName) => {
    if (!oldName || !newName || oldName === newName) return;
    if (instances[oldName] !== undefined) {
      instances[newName] = instances[oldName];
      delete instances[oldName];
    }
  },

  setAllInstances: (newInstances) => {
    // Clear and replace the entire instance map
    instances = JSON.parse(JSON.stringify(newInstances));
  },
  

  getInstancesByLayer: (layerId) => instances[layerId] || [],


  getInstancesByCellAndLayer: (cellName, layerId) => {
    return instances[cellName]?.[layerId] || [];
  },  

  // Add to InstanceLibrary object
// RectangleLibrary.js

setLayerVisibility: (layerId, isVisible) => {
  // 1) existing: in-memory instances
  for (const cellName in instances) {
    if (instances[cellName][layerId]) {
      instances[cellName][layerId].forEach(rect => {
        rect.visible = isVisible;
      });
    }
  }

  // 2) NEW: mirror to layoutEngine cells (created + uploaded), like updateColorByLayer
  for (const cellName in instances) {
    const layoutCell   = layoutEngine.getCellByName(cellName);
    const uploadedCell = layoutEngine.getUploadedCell(cellName);

    [layoutCell, uploadedCell].forEach(cell => {
      if (cell?.elements?.length) {
        cell.elements.forEach(el => {
          if (el.type === 'rectangle' && el.layerId === layerId) {
            el.visible = isVisible;
          }
        });
      }
    });
  }
},


  setAllLock: (layerId, isLocked) => {
  // 1) In-memory rectangles
  for (const cellName in instances) {
    if (instances[cellName][layerId]) {
      instances[cellName][layerId].forEach(rect => {
        rect.locked = isLocked;
      });
    }
  }

  // 2) Mirror to ALL layoutEngine cells (created + uploaded)
  const allCells = [...layoutEngine.getCells(), ...layoutEngine.getUploadedCells()];
  allCells.forEach(cell => {
    if (cell?.elements?.length) {
      cell.elements.forEach(el => {
        if (el.type === 'rectangle' && el.layerId === layerId) {
          el.locked = isLocked;
        }
      });
    }
  });
},


// RectangleLibrary.js
drawUploadedRectangle(ctx, rect, scale = 1) {
  // (optional) agar tumne pehle se guard add kiya hai to yeh rehne do:
  // if (rect?.visible === false) return;
  // const L = rect.layerNumber ?? rect.layer;
  // const D = rect.datatypeNumber ?? rect.datatype ?? 0;
  // if (L != null && String(L) !== '' && !layerLibrary.isLayerVisible(L, D)) return;

  // Geometry
  const x = rect.x1 ?? rect.x;
  const y = rect.y1 ?? rect.y;
  const width  = rect.x2 ? rect.x2 - rect.x1 : rect.width;
  const height = rect.y2 ? rect.y2 - rect.y1 : rect.height;

  // Layer + styles
  const layerId = rect.layerId || `${rect.layer ?? rect.layerNumber}:${rect.datatype ?? rect.datatypeNumber ?? 0}`;
  const layer   = layerLibrary.getLayerById(layerId);

  const fill   = rect.fill   || layer?.color || "rgba(0,255,0,0.4)";
  const stroke = rect.stroke || layer?.color || "green";

  // 🔑 Final alpha: rect.opacity set hoti hai via LayerLibrary.updateOpacity → InstanceLibrary.updateOpacityByLayer
  // Fallback: layer.pattern.opacity agar rect.opacity missing ho
  const alpha = (rect.opacity ?? layer?.pattern?.opacity ?? 1);

  // Draw
  ctx.beginPath();
  ctx.fillStyle   = fill;
 
  ctx.lineWidth   = 1 / scale;

  const cx = x + width / 2;
  const cy = y + height / 2;

  ctx.save();
  ctx.translate(cx, cy);
  ctx.rotate((rect.rotation || 0) * Math.PI / 180);
  ctx.translate(-cx, -cy);

  ctx.rect(x, y, width, height);

  // ✅ fill + stroke dono opacity follow karenge
  ctx.globalAlpha = alpha;
  ctx.fill();
  
  ctx.globalAlpha = 1;

  ctx.restore();
},
  

  updateOpacityByLayer(layerId, opacity) {
  for (const cellName in instances) {
    for (const lid in instances[cellName]) {
      if (lid === layerId) {
        instances[cellName][lid].forEach(rect => {
          rect.opacity = opacity;
        });
      }
    }

    // 🔁 Update uploadedCell + layoutCell shapes too
    const layoutCell = layoutEngine.getCellByName(cellName);
    const uploadedCell = layoutEngine.getUploadedCell(cellName);

    [layoutCell, uploadedCell].forEach(cell => {
      if (cell?.elements?.length) {
        cell.elements.forEach(el => {
          const isMatch = el.layerId === layerId && el.type === 'rectangle';
          if (isMatch) {
            el.opacity = opacity;
          }
        });
      }
    });
  }
},
drawSingle(ctx, rect, scale = 1) {
  let x, y, width, height;
  
  if (rect.x1 !== undefined && rect.y1 !== undefined) {
    x = rect.x1;
    y = rect.y1;
    width = rect.x2 - rect.x1;
    height = rect.y2 - rect.y1;
  } else {
    x = rect.x;
    y = rect.y;
    width = rect.width;
    height = rect.height;
  }

  // Always get the latest layer color
  const layerId = rect.layerId || `${rect.layerNumber ?? rect.layer}:${rect.datatypeNumber ?? rect.datatype ?? 0}`;
  const layer = layerLibrary.getLayerById(layerId);
  
  ctx.beginPath();
  ctx.fillStyle = rect.fill || hexToRgba(layer?.color, 0.4);
  ctx.strokeStyle = rect.stroke || layer?.color || 'green';
  ctx.lineWidth = 1 / scale;
  ctx.globalAlpha = rect.opacity ?? 1;


  const cx = x + width / 2;
  const cy = y + height / 2;

  ctx.save();
  ctx.translate(cx, cy);
  ctx.rotate((rect.rotation || 0) * Math.PI / 180);
  ctx.translate(-cx, -cy);

  ctx.rect(x, y, width, height);
  ctx.fill();
  ctx.globalAlpha = 1;
  ctx.stroke();

  ctx.restore();
},

  drawAll: (ctx, offsetX, offsetY, scale, activeCellName, previewRect) => {
    ctx.save();
    ctx.translate(offsetX, offsetY);
    ctx.scale(scale, scale);
  
    const cellLayers = instances[activeCellName] || {};
    const hasInstances = Object.keys(cellLayers).some(layerId => cellLayers[layerId]?.length > 0);
    
    if (hasInstances) {
      for (const layerId in cellLayers) {
        const items = cellLayers[layerId];
        for (const inst of items) {
          if (inst.visible === false) continue; // Skip invisible rectangles
          ctx.beginPath();
          ctx.fillStyle = inst.fill;
          ctx.strokeStyle = inst.stroke;
          ctx.lineWidth = 1 / scale;
          ctx.globalAlpha = inst.opacity ?? 1;

  
          const cx = inst.x + inst.width / 2;
          const cy = inst.y + inst.height / 2;
  
          ctx.save();
          ctx.translate(cx, cy);
          ctx.rotate((inst.rotation || 0) * Math.PI / 180);
          ctx.translate(-cx, -cy);
  
          ctx.rect(inst.x, inst.y, inst.width, inst.height);
          ctx.fill();
          ctx.stroke();
          ctx.globalAlpha = 1;

  
          ctx.restore();
        }
      }
    } else {
      const cell = layoutEngine.getCellByName(activeCellName);
      if (cell && cell.elements?.length) {
        for (const el of cell.elements) {
          if (el.type === "rectangle") {
            let x = el.x1 ?? el.x;
            let y = el.y1 ?? el.y;
            let width = el.x2 ? el.x2 - el.x1 : el.width;
            let height = el.y2 ? el.y2 - el.y1 : el.height;
  
            const layer = layerLibrary.getLayerById(`${el.layer}:${el.datatype ?? 0}`);
            const fill = layer?.color || "rgba(0,255,0,0.3)";
            const stroke = layer?.color || "green";
  
            ctx.beginPath();
            ctx.fillStyle = fill;
            ctx.strokeStyle = stroke;
            ctx.lineWidth = 1 / scale;
  
            const cx = x + width / 2;
            const cy = y + height / 2;
  
            ctx.save();
            ctx.translate(cx, cy);
            ctx.rotate((el.rotation || 0) * Math.PI / 180);
            ctx.translate(-cx, -cy);
  
            ctx.rect(x, y, width, height);
            ctx.fill();
            ctx.stroke();
  
            ctx.restore();
          }
        }
      }
    }
  
    if (previewRect) {
      ctx.beginPath();
      ctx.setLineDash([4, 2]);
      ctx.strokeStyle = "#fff";
      ctx.lineWidth = 1 / scale;
      ctx.rect(previewRect.x, previewRect.y, previewRect.width, previewRect.height);
      ctx.stroke();
      ctx.setLineDash([]);
    }
  
    ctx.restore();
  },  
  
  deleteRectangle,
};

export default InstanceLibrary;
